import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginService } from '../../services/login.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
    standalone: true,
    imports: [
    ReactiveFormsModule
]
})
export class LoginComponent implements OnInit {
  private loginService = inject(LoginService);

  ngOnInit(): void {
    this.loginService.InitializeLoginState();
  }

  Login() {
    this.loginService.Login();
  }
}
